import { render } from "./formGeneratorPermissions.vue?vue&type=template&id=4285feed&scoped=true"
import script from "./formGeneratorPermissions.vue?vue&type=script&lang=js"
export * from "./formGeneratorPermissions.vue?vue&type=script&lang=js"

import "./formGeneratorPermissions.vue?vue&type=style&index=0&id=4285feed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4285feed"]])

export default __exports__